import { SORT_TYPES_ARRAY } from '../constants';
import { selectFilterId } from '../selectors';
import * as types from '../types';

function _setSortType(filterId, sortType) {
    return {
        meta: filterId,
        payload: sortType,
        type: types.SET_SORT_TYPE,
    };
}

function setSortType(sortType, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || selectFilterId(getState());

        if (!SORT_TYPES_ARRAY.includes(sortType)) {
            return;
        }

        return dispatch(_setSortType(filterId, sortType));
    };
}

export {
    setSortType,
};
